var $7e23baec8a14f309$exports = {};
$7e23baec8a14f309$exports = {
    "breadcrumbs": `Categorias`
};


export {$7e23baec8a14f309$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
